import axios from 'axios';

import { CreateEventReasonTaggingPayload, EventReason } from 'types/models/event-reason';
import { APIResponseParsed } from 'types/response';
import { getRequest, postRequest } from 'utils/HttpRequest/http-request-utils';

import { parseAxiosError } from './utils/parse-axios-error';

async function fetchEventReasons(): Promise<APIResponseParsed<EventReason[]>> {
  try {
    const response = await getRequest<EventReason[]>('event-reasons');
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

async function createEventReasonTagging(
  payload: CreateEventReasonTaggingPayload
): Promise<APIResponseParsed<'OK'>> {
  try {
    await postRequest<unknown, CreateEventReasonTaggingPayload>('event-reason-tagging', payload);
    return { data: 'OK', error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

export default {
  createEventReasonTagging,
  fetchEventReasons
};
